export type Reason = {
  [key: string]: {
    title: string;
    text?: string;
    hasTextField?: boolean;
  };
}

export const REASONS: Reason = {
  lackOfCertainFeatures: {
    title: 'Missing Features:',
    text: 'Please specify which features you needed:',
    hasTextField: true
  },
  financialReasons: {
    title: 'Financial Reasons:',
    text: 'Would you reconsider staying if we could adjust your payment plan or temporarily pause your subscription?',
  },
  switchingSoftwareProviders: {
    title: 'Switching to Another Provider:',
    text: "Please tell us why you're making the switch:",
    hasTextField: true
  },
  closingYourBusiness: {
    title: 'Closing or Changing My Business:',
    text: 'Please briefly describe your situation (Optional):',
    hasTextField: true
  },
  technicalIssues: {
    title: 'Technical Issues or Poor Experience:',
    text: 'Can you describe what went wrong?',
    hasTextField: true
  },
  other: {
    title: 'Other (Please Specify):',
    hasTextField: true
  },
};

export type CancelSubscriptionForm = {
  reason: string;
  reasonDetails?: string;
  followUp?: string;
  contactInfo?: string;
}

export const INITIAL_VALUES = {
  reason: "",
  reasonDetails: "",
  followUp: "",
  contactInfo: "",
}
